export default __webpack_public_path__ + "static/media/nectar_a_whopperflower.ba81a596.png";